<template>
  <div class="footer-wrapper">
    <div class="footer" :class="{
        'is-landing': type === 'landing',
        'is-adaptive': is_adaptive,
        'public-response': public_response,
        'grid': is_grid
      }">
      <div>
        <a class="footer-copyright-img" target="_blank" rel="noopener" :href="`https://${domainLink}/`">
          <img src="/static/images/elements/footer-recruiter.svg">
        </a>
        <span class="copyright footer-group">{{ $tr('copyright_landing', {
          year: this.year
        }) }}</span>
      </div>
    </div>
  </div>
</template>

<script>

  import { mapState } from 'vuex'

  export default {
    name: 'vcv-footer',
    props: {
      type: {
        type: String,
        default: 'main'
      },
      domain: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        year: new Date().getFullYear()
      }
    },
    computed: {
      ...mapState(['locale']),
      domainLink () {
        switch (this.domain || this.locale.value) {
          case 'ru':
            return 'vcv.ru'
          default:
            return 'vcv.ai'
        }
      },
      is_grid () {
        return this.$route.name === 'vacancy_application' || this.$route.name === 'vacancy_tests';
      },
      is_adaptive () {
        return this.$route.meta ? this.$route.meta.is_adaptive : null
      },
      public_response () {
        return this.$route.meta ? this.$route.meta.public_response : null
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../styles/colors.scss";
  @import "../../styles/queries.scss";

  .footer-wrapper {
    position: relative;
    background-color: #FFF;
    border-top: 1px solid #D2D6E0;
    min-height: 59px;
    box-sizing: border-box;
    padding: 12px 0;
    margin-top: auto;
    margin-bottom: 0;
    display: flex;
    justify-content: center;
    .footer {
      width: 100%;
      margin-right: auto;
      margin-left: auto;
      padding: 0 24px;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: space-between;

      // @include widescreen {
      //   max-width: 1200px;
      // }

      @include desktop {
        max-width: 970px;
      }

      @include tablet {
        max-width: 920px;
        padding-left: 20px;
        padding-right: 20px;
      }

      // @include mobile {
      //   max-width: 320px;
      // }

      &:not(.is-landing):not(.is-adaptive):not(.public-response):not(.grid) {
        @include desktop {
          padding-left: 20px;
          padding-right: 20px;
          max-width: 100%;
          min-width: 100%;
          box-sizing: border-box;
        }

        @include tablet {
          max-width: 100%;
          min-width: 100%;
          padding-left: 20px;
          padding-right: 20px;
          box-sizing: border-box;
        }

        @include mobile {
          max-width: 100%;
          min-width: 100%;
          padding-left: 20px;
          padding-right: 20px;
          box-sizing: border-box;
        }
      }

      .copyright {
        font-weight: 100;
        color: #9FAAB6;
      }

      > div {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
      }

      .footer-group {
        display: inline-block;
        margin: 5px 20px 5px 0;
        // // font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 13px;
        line-height: 19px;
        color: #9FAAB6;
      }
      .link {
        white-space: nowrap;
      }

      .logo-icon {
        width: 24px;
      }
    }
  }

  .footer-copyright-img {
    margin-right: 9px;
  }

  // IE-FIX
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    .footer-wrapper {
      position: absolute;
      bottom: 0px;
      width: 100%;
    }
  }
</style>
